/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';
import TimerIcon from '../icons/Timer';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/game-timer.module.scss';

const propTypes = {
    duration: PropTypes.number,
    started: PropTypes.bool,
    speed: PropTypes.number,
    trailingText: PropTypes.string,
    withoutIcon: PropTypes.bool,
    className: PropTypes.string,
    timeClassName: PropTypes.string,
    onComplete: PropTypes.func,
    onChange: PropTypes.func,
};

const defaultProps = {
    duration: 30,
    started: false,
    speed: 1,
    trailingText: 's',
    withoutIcon: false,
    className: null,
    timeClassName: null,
    onComplete: null,
    onChange: null,
};

function GameTimer({
    duration,
    started,
    speed,
    trailingText,
    withoutIcon,
    className,
    timeClassName,
    onComplete,
    onChange,
}) {
    const themeClassName = useThemeClassName(styles);
    const [running, setRunning] = useState(started);
    const [time, setTime] = useState(duration);
    const lastTickTime = useRef(null);

    useEffect(() => {
        setRunning(started);
    }, [started]);

    useEffect(() => {
        lastTickTime.current = duration;
        setTime(duration);
    }, [duration]);

    useEffect(() => {
        let timeout = null;
        if (running && lastTickTime.current !== null && lastTickTime.current >= -1) {
            timeout = setInterval(() => {
                lastTickTime.current -= speed;
                const nextTime = Math.max(lastTickTime.current, 0);
                setTime(nextTime);
            }, speed * 1000);
        }
        return () => {
            if (timeout !== null) {
                clearInterval(timeout);
            }
        };
    }, [running, speed, setTime]);

    useEffect(() => {
        if (time === 0 && started && onComplete !== null) {
            onComplete();
        }
        if (onChange !== null) {
            onChange(time);
        }
    }, [time, started]);

    const timeInSeconds = time;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.almostDone]: timeInSeconds < 8 && timeInSeconds > 0,
                    [styles.urgent]: timeInSeconds < 4 && timeInSeconds > 0,
                },
                themeClassName,
                className,
            ])}
        >
            <div className={styles.pill}>
                {!withoutIcon ? <TimerIcon className={styles.icon} /> : null}

                <div
                    className={classNames([
                        styles.time,
                        { [timeClassName]: timeClassName !== null },
                    ])}
                >
                    {Math.round(timeInSeconds)}
                    {trailingText}
                </div>
            </div>
        </div>
    );
}

GameTimer.propTypes = propTypes;
GameTimer.defaultProps = defaultProps;

export default GameTimer;
